import { render, staticRenderFns } from "./SiteAppsAppAvailable.vue?vue&type=template&id=37d3738c&scoped=true&"
import script from "./SiteAppsAppAvailable.vue?vue&type=script&lang=js&"
export * from "./SiteAppsAppAvailable.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsAppAvailable.vue?vue&type=style&index=0&id=37d3738c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3738c",
  null
  
)

export default component.exports